import { render, staticRenderFns } from "./AdminAddIncome.vue?vue&type=template&id=4aac7a40&"
import script from "./AdminAddIncome.vue?vue&type=script&lang=js&"
export * from "./AdminAddIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports